exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".faq {\n  width: 90%;\n  max-width: 900px;\n  margin: 30px auto 0 auto; }\n  .faq .faq-container {\n    padding: 20px 40px;\n    width: 100%;\n    height: 100%;\n    background-color: #ffffff; }\n    .faq .faq-container .faq-heading {\n      margin-bottom: 20px;\n      text-align: center;\n      color: #673bb7;\n      font-size: 32px; }\n\n@media (max-width: 480px) {\n  .faq .faq-container {\n    padding: 10px 20px; }\n    .faq .faq-container ul, .faq .faq-container ol {\n      padding-left: 20px; } }\n\n@media (max-width: 375px) {\n  .faq .faq-container {\n    padding: 10px 15px; }\n    .faq .faq-container ul ul {\n      padding-left: 10px; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/components/faq/faq.scss
// module id = ./node_modules/css-loader/index.js!./node_modules/sass-loader/lib/loader.js!./src/components/faq/faq.scss
// module chunks = index